<template>
    <div
        class="moreMarketDisplay notranslate"
        v-bind:class="{ _show: isMarketShow }"
    >
        <div
            class="moreMarketDisplay_type"
            v-bind:class="{ _isMarketShow: isMarketShow }"
            v-on:click="changeMarketShow()"
        >
            <div>
                {{ market.name }}
            </div>
            <SvgIcon class="rotate" iconName="systemIcon_arrowBottom" />
        </div>
        <TransitionCollapse>
            <div v-show="isMarketShow" class="marketCard-content">
                <div class="oddsBoxPack">
                    <Selection
                        v-for="selection in visibleSelections"
                        v-bind:key="selection.id"
                        v-bind:match="match"
                        v-bind:market="market"
                        v-bind:selection="selection"
                        v-bind:displaySection="displaySection"
                    />
                    <button
                        v-if="hasMoreSelections"
                        type="button"
                        class="moreMarketDisplay_expandButton"
                        v-bind:aria-expanded="isShowMore"
                        v-on:click="toggleShowMore"
                    >
                        {{ showMoreButtonText }}
                        <SboIcon
                            name="system:arrowDown"
                            class="icon"
                            size="14"
                            v-bind:rotated="isShowMore"
                        />
                    </button>
                </div>
            </div>
        </TransitionCollapse>
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import { computed, ref, watch } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import TransitionCollapse from '@/components/common/TransitionCollapse.vue';
    import Selection from '@/components/match/Selection.vue';
    import type { IMarket, IMatch } from '@/interface/IMatch';
    import { DisplaySection } from '@/interface/enum';
    import { i18n } from '@/libraries/i18n';
    import SvgIcon from '@/svg/SvgIcon.vue';

    const props = defineProps({
        market: {
            type: Object as PropType<IMarket>,
            default: () => ({}),
        },
        isCollapse: {
            type: Boolean,
            default: false,
        },
        match: {
            type: Object as PropType<IMatch>,
            default: () => ({}),
        },
        displaySection: {
            type: Number as PropType<DisplaySection>,
            default: DisplaySection.Unknown,
        },
    });

    const isMarketShow = ref(false);

    function changeMarketShow() {
        isMarketShow.value = !isMarketShow.value;
    }

    watch(() => props.isCollapse, (newVal) => {
        isMarketShow.value = newVal;
    });

    const DYNAMIC_MARKET_DEFAULT_VISIBLE_COUNT = 7;

    const isShowMore = ref(false);

    const hasMoreSelections = computed(() => props.market.selections.length > DYNAMIC_MARKET_DEFAULT_VISIBLE_COUNT);

    const visibleSelections = computed(() => (isShowMore.value
        ? props.market.selections
        : props.market.selections.slice(0, DYNAMIC_MARKET_DEFAULT_VISIBLE_COUNT)));

    const showMoreButtonText = computed(() => i18n.t(isShowMore.value ? 'cta_show_less' : 'cta_show_more'));

    function toggleShowMore() {
        isShowMore.value = !isShowMore.value;
    }
</script>

<style lang="scss" scoped>
    @import "@/scss/components/moreMarket";
</style>
